import { AfterViewInit, Component, ElementRef, inject, TemplateRef, ViewChild } from '@angular/core';
import { InputStaticFieldsComponent } from '../../input-static-fields/input-static-fields.component';
import { CheckboxComponent } from '../../checkbox/checkbox.component';
import { ImageSideComponent } from '../../image-side/image-side.component';
import { LoaderService } from '../../../services/loader/loader.service';
import { NgbModal, type NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ForgetPasswordComponent } from '../../forget-password/component/forget-password.component';
import { Store } from '@ngrx/store';
import { AuthService } from '../../../services/auth.service';
import { getError } from '../../../../../store/authentication/authentication.selector';
import { Router } from '@angular/router';
import { ToasterService } from '../../../services/toaster/toaster.service';
import { TranslationService } from '../../../services/translation/translation.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { GlobalService } from '../../../services/common/global.service';
import { LoggingService } from '../../../services/logging-service';
import { HttpClient } from '@angular/common/http';
import { LoginService } from '../service/login.service';
import { CommonModule } from '@angular/common';
import { SetNewPasswordComponent } from '../../set-new-password/component/set-new-password.component';
import { noWhitespaceValidator } from '../../../helper/validtors-helper';
import { BackgroundService } from '../../../services/background-service/background.service';
import { environment } from '../../../../../environments/environment';

declare const turnstile: any;
@Component({
  selector: 'app-login',
  imports: [
    InputStaticFieldsComponent,
    CheckboxComponent,
    ImageSideComponent,
    ForgetPasswordComponent,
    ReactiveFormsModule,
    CommonModule,
    SetNewPasswordComponent,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements AfterViewInit {
  public router = inject(Router);
  public globalService = inject(GlobalService);
  public store = inject(Store);
  public service = inject(AuthService);
  private modalService = inject(NgbModal);
  private loadingService = inject(LoaderService);
  private toastService = inject(ToasterService);
  private translationService = inject(TranslationService);
  public loginForm!: FormGroup;
  public loginService = inject(LoginService);

  showErrorDiv: boolean = false;
  currentMessage: string = 'Username or Password is invalid';
  icon: string = 'fs-3 ti ti-bomb';
  messageTextClass: string = 'text-danger-emphasis';
  currentClass: string = 'bg-danger-subtle p-2';

  @ViewChild('passwordModal') passwordModal!: TemplateRef<any>;
  @ViewChild('turnstileContainer') turnstileContainer!: ElementRef<HTMLDivElement>;

  turnstileToken: string | null = null;
  private turnstileWidgetId: string | null = null;

  constructor(
    public fb: FormBuilder,
    private loggingService: LoggingService,
    private authService: AuthService,
    private backgroundService : BackgroundService
  ) {
    // if (localStorage.getItem(this.authService.userLastRoute) != null && this.authService.checkAuthStatus()) {
    //   this.router.navigateByUrl(localStorage.getItem(this.authService.userLastRoute)!);
    //   return;
    // }
    // Check localStorage for saved user data
    let savedUser = null;
    try {
      savedUser = JSON.parse(localStorage.getItem('user') || 'null');
    } catch (e) {
      savedUser = null;
    }
    console.log(savedUser)
    this.loginForm = this.fb.group({
      username: [savedUser?.remember_me ? savedUser.username : '', [Validators.required, noWhitespaceValidator]],
      password: [savedUser?.remember_me ? savedUser.password : '', [Validators.required, noWhitespaceValidator]],
      rememberMe: [savedUser?.remember_me ? true : false],
    });

    console.log(this.loginForm.value)
  }
  get isLocalhost(): boolean {
    return (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    );
  }

  ngAfterViewInit(): void {
    if (this.isLocalhost) {
      return;
    }
    this.renderTurnstileWidget();
  }

  private renderTurnstileWidget(attempt: number = 0): void {
    if (this.hideLoginUI || !this.turnstileContainer) {
      return;
    }
    if (typeof turnstile === 'undefined') {
      if (attempt < 50) {
        setTimeout(() => this.renderTurnstileWidget(attempt + 1), 100);
      }
      return;
    }
    this.turnstileWidgetId = turnstile.render(this.turnstileContainer.nativeElement, {
      sitekey: environment.turnstileSiteKey,
      size: 'flexible',
      callback: (token: string) => {
        this.turnstileToken = token;
      },
      'expired-callback': () => {
        this.turnstileToken = null;
      },
      'error-callback': () => {
        this.turnstileToken = null;
      },
    });
  }

  private resetTurnstileWidget(): void {
    this.turnstileToken = null;
    if (typeof turnstile !== 'undefined' && this.turnstileWidgetId) {
      turnstile.reset(this.turnstileWidgetId);
    }
  }

  get hideLoginUI(): boolean {
    return this.router.url.startsWith('/onlineconsent');
  }
  openModal(
    event: Event,
    content: TemplateRef<HTMLElement>,
    options: NgbModalOptions,
  ) {
    event.preventDefault();
    const modalOptions: NgbModalOptions = {
      ...options,
      backdrop: 'static',
      keyboard: false,
    };

    this.modalService.open(content, modalOptions);
  }
  handleModalDismiss() {
    this.modalService.dismissAll();

  }

  handleEmail(email: string) {
    // Logic to handle the email
  }
  switchLanguage(event: any) {
    this.translationService.setLanguage(event.target.value);
  }

  translate(key: string): string {
    return this.translationService.translate(key);
  }

  close() {
    this.showErrorDiv = false;
  }
  passwordChanged(value: any) {
    if (value != null) {
      this.showErrorDiv = true;
      this.currentMessage = 'Password changed successfully!';
      this.icon = 'fs-3 ti ti-checks';
      setTimeout(() => {
        this.showErrorDiv = false;
      }, 5000);
    }
  }
  submitForm(event: Event) {
    event.preventDefault();
    if (!this.isLocalhost && !this.turnstileToken) {
      this.showErrorDiv = true;
      this.currentMessage = 'Please verify you are human';
      setTimeout(() => {
        this.showErrorDiv = false;
      }, 5000);
      return;
    }
    this.currentMessage = 'Username or Password is invalid';
    // Store user info in localStorage if rememberMe is checked
    const { username, password, rememberMe } = this.loginForm.value;
    if (rememberMe) {
      localStorage.setItem(
        'user',
        JSON.stringify({ username, password, remember_me: rememberMe }),
      );
    } else {
      localStorage.removeItem('user');
    }
    // Login Api
    this.loadingService.showSpinner();
    const turnstileToken: string | false = this.isLocalhost ? "" : this.turnstileToken!;
    this.loginService.login(username, password, this.isLocalhost, turnstileToken).subscribe((data) => {
      this.resetTurnstileWidget();
      if (data == 'authenticated') {
         console.log("\n🔐 %cAuthentication Service Started", "color: #4CAF50; font-weight: bold;");
         console.log("%c──────────────────────────────────────────────────────────────", "color: #9E9E9E;");
         console.log("%cDEBUG:INFO → Authentication service initialization...", "color: #2196F3;");
         console.log("%c──────────────────────────────────────────────────────────────\n", "color: #9E9E9E;");
        //  this.backgroundService.startTask();
        this.loadingService.stopSpinner();
        this.loggingService.logSuccess(
          'login successfully',
          this.loginForm.value,
        );
        // if (localStorage.getItem(this.authService.userLastRoute) != null && localStorage.getItem(this.authService.userLastRoute) != "/") {
        //   this.router.navigateByUrl(localStorage.getItem(this.authService.userLastRoute)!);
        //   return;
        // }
        this.router.navigateByUrl('/usertype');
      } else if (data == 'set pasword') {
        this.loadingService.stopSpinner();
        this.openModal(event, this.passwordModal, { centered: true });
      } else {
        this.showErrorDiv = true;
        setTimeout(() => {
          this.showErrorDiv = false;
        }, 5000);
        this.loadingService.stopSpinner();
      }
    });
  }
}
